import React, {useContext, useState} from "react";
import UserContext from "../common/UserContext";

//multilingual
import {useLocalization} from "@progress/kendo-react-intl";
import {mainMessages, reviewAndSubmitKey} from "../../assets/text/MultilingualText";

//components
import ReviewBanked from "./ReviewSubmit/ReviewBanked";
import SubmitBanked from "./ReviewSubmit/SubmitBanked";
import ReviewTransport from "./ReviewSubmit/ReviewTransport";
import SubmitTransport from "./ReviewSubmit/SubmitTransport";

export default function ReviewSubmit(props) {
    const {
        siteLanguageDefault
    } = useContext(UserContext);
    const localization = useLocalization();

    const {
        xAuthToken,
        handleBeforeUnload,
        stepperItems,
        setStepperItems,
        changeStepActivation,
        setIsLoading,
        transport,
        licenses,
        setLicenses,
        unassigned,
        setUnassigned,
        assigned,
        setAssigned,
        setNoLongerValid,
        setGeneralError,
        addForm,
        setSaveError,
    } = props

    const [review, setReview] = useState(true)
    const showActivationCodeColumn = assigned.some(host => host.products.some(item => !!item.activation_code));

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.938rem',
        }}>
            <div className={"k-h5"}>
                {localization.toLanguageString(reviewAndSubmitKey, mainMessages[siteLanguageDefault][reviewAndSubmitKey])}
            </div>

            {review && !transport && (
                <ReviewBanked
                    assigned={assigned}
                    setReview={setReview}
                    showActivationCodeColumn={showActivationCodeColumn}
                />
            )}

            {!review && !transport && (
                <SubmitBanked
                    stepperItems={stepperItems}
                    setStepperItems={setStepperItems}
                    changeStepActivation={changeStepActivation}
                    assigned={assigned}
                    licenses={licenses}
                    setLicenses={setLicenses}
                    xAuthToken={xAuthToken}
                    setIsLoading={setIsLoading}
                    setNoLongerValid={setNoLongerValid}
                    setGeneralError={setGeneralError}
                    addForm={addForm}
                    setSaveError={setSaveError}
                    showActivationCodeColumn={showActivationCodeColumn}
                />
            )}

            {review && transport && (
                <ReviewTransport
                    setIsLoading={setIsLoading}
                    unassigned={unassigned}
                    setUnassigned={setUnassigned}
                    assigned={assigned}
                    setAssigned={setAssigned}
                    setReview={setReview}
                    showActivationCodeColumn={showActivationCodeColumn}
                />
            )}

            {!review && transport && (
                <SubmitTransport
                    setIsLoading={setIsLoading}
                    handleBeforeUnload={handleBeforeUnload}
                    stepperItems={stepperItems}
                    setStepperItems={setStepperItems}
                    changeStepActivation={changeStepActivation}
                    assigned={assigned}
                    setAssigned={setAssigned}
                    licenses={licenses}
                    setLicenses={setLicenses}
                    xAuthToken={xAuthToken}
                    addForm={addForm}
                    showActivationCodeColumn={showActivationCodeColumn}
                />
            )}
        </div>
    )
}
